/**
 * Map Amplify/Cognito auth errors to user-facing copy.
 * Cognito ForgotPassword soft-limits attempts (AWS-side); we cannot raise them.
 */

const DEFAULT_RATE_LIMIT_WAIT =
  'Too many password reset attempts. Please wait about 15 minutes, then try again.'

export function isLimitExceededError(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false
  const name = 'name' in err ? String((err as { name?: string }).name) : ''
  const message = 'message' in err ? String((err as { message?: string }).message) : ''
  return (
    name === 'LimitExceededException' ||
    name === 'TooManyRequestsException' ||
    /attempt limit exceeded/i.test(message) ||
    /too many requests/i.test(message) ||
    /exceeded.*limit/i.test(message)
  )
}

/** Cognito blocks ForgotPassword for FORCE_CHANGE_PASSWORD (never set a real password). */
export function isForceChangePasswordResetError(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false
  const name = 'name' in err ? String((err as { name?: string }).name) : ''
  const message = 'message' in err ? String((err as { message?: string }).message) : ''
  return (
    name === 'NotAuthorizedException' &&
    /cannot be reset in the current state/i.test(message) &&
    !/disabled/i.test(message)
  )
}

export function authErrorMessage(err: unknown, fallback: string): string {
  if (isLimitExceededError(err)) return DEFAULT_RATE_LIMIT_WAIT
  if (err instanceof Error && err.message) {
    if (/user is disabled/i.test(err.message)) {
      return (
        'This account has been disabled. Contact Ascend Health if you need access restored.'
      )
    }
    return err.message
  }
  return fallback
}

export const PASSWORD_RESET_COOLDOWN_MS = 60_000
